import { findMock } from "../../app/mocks/Mocks";
import { AuthError } from "../lib/error/AuthError";
import { MyError } from "../lib/error/MyError";

let refreshPromise: Promise<string> | null = null;

const getErrorMessage = async (res: Response): Promise<string> => {
    const text = await res.text();

    if (!text) {
        return 'Ошибка авторизации';
    }

    try {
        const data = JSON.parse(text) as {message?: string; error?: string};
        return data.message || data.error || text;
    }
    catch {
        return text;
    }
}

async function refreshToken(): Promise<string> {
    const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/auth/auth/refresh`, {
        method: 'GET',
        credentials: 'include'
    });

    if (!res.ok) {
        const message = await getErrorMessage(res);
        throw new AuthError(message, res.status);
    }

    const data: {token?: string} = await res.json();

    if (!data.token) {
        throw new AuthError('Не удалось обновить токен');
    }

    return data.token;
}

const getRefreshPromise = (): Promise<string> => {
    if (!refreshPromise) {
        refreshPromise = refreshToken().finally(() => {
            refreshPromise = null;
        });
    }

    return refreshPromise;
}

export async function handleUnauthorized(requestFn: () => Promise<Response>): Promise<Response> {
    try {
        const newToken = await getRefreshPromise();
        localStorage.setItem('auth_token', newToken);
        return requestFn();
    }
    catch (error) {
        localStorage.removeItem('auth_token');
        throw error;
    }
}

export const fetchAuth = async (url: string, init?: RequestInit, isRetry?: boolean, myContentType?: boolean): Promise<Response> => {
    const newInit: RequestInit = {...init};

    if (process.env.REACT_APP_USE_MOCK === 'true') {
        const res = await findMock(url, init);
        if (res) {
            return res as Response;
        }
    }

    newInit.headers = (myContentType ?
        {
            ...newInit.headers,
            'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
        }
        :
        {
            ...newInit.headers,
            'Content-Type': 'application/json;charset=utf-8',
            'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
        });

    newInit.credentials = 'include';
    const res = await fetch(url, newInit);

    if (!res.ok) {
        if (res.status === 401 && !isRetry) {
            return handleUnauthorized(() => fetchAuth(url, init, true, myContentType));
        }

        if (res.status === 401) {
            const message = await getErrorMessage(res);
            throw new AuthError(message, res.status);
        }

        if (res.status === 403) {
            const message = await getErrorMessage(res);
            throw new AuthError(message || 'Нет прав на выполнение действия', res.status);
        }

        const message = await getErrorMessage(res);
        throw new MyError(message || 'Ошибка в запросе', res.status);
    }

    return res;
}
